module.exports = __webpack_public_path__ + "img/EaseDonDoff.0b1658ce.svg";